import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Availability from "./Availability";
import Checkout from "./Checkout";
import Contracts from "./Contracts";
// import ErrorBoundary from "./ErrorBoundary";

function App() {
  return (
    <div className="flex bg-gray-100 h-full min-h-screen border-t-8 border-blue-400">
      <Router>
        <Switch>
          <Route path={`/hotel_partners/:uuid/contracts/:contractNumber`}>
            <Checkout />
          </Route>
          <Route path="/hotel_partners/:uuid/contracts">
            <Contracts />
          </Route>
          <Route path="/hotel_partners/:uuid">
            <Availability />
          </Route>
          <Route path="*">
            <div
              className="flex container mx-auto items-center justify-center"
              style={{ height: "100vh" }}>
              <div>
                <span className="font-bold mr-2 text-4xl">404</span>
                <span className="font-thin text-5xl">|</span>
                <span className="font-thin ml-2 text-4xl">Not Found</span>
              </div>
            </div>
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
